// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

import { sendData as sendDataToWS } from '../index'

/**
 * @fileoverview
 * Chat related WS commands
 */

export const getConversations = ({
  ack,
  first,
  after,
  archived,
  onlySpyChats,
}) =>
  sendDataToWS({
    action: 'CHAT_GET_CONVERSATION_LIST',
    ack,
    first,
    after,
    archived,
    onlySpyChats,
  })

export const getConversation = ({ conversationId, missionId, ack }) =>
  sendDataToWS({
    action: 'CHAT_GET_CONVERSATION',
    conversationId,
    missionId,
    ack,
  })

export const createConversation = ({
  messagePayload,
  endUserIds,
  cityIds,
  missionId,
  ack,
}) =>
  sendDataToWS({
    action: 'CHAT_CREATE_CONVERSATION',
    payload: messagePayload,
    ack,
    endUserIds,
    cityIds,
    missionId,
  })

export const sendMessage = ({
  messagePayload,
  conversationId,
  dispatchPayload,
  ack,
}) => {
  return sendDataToWS({
    action: 'CHAT_SEND_MESSAGE',
    payload: messagePayload,
    conversationId,
    ack,
    dispatchPayload,
  })
}

export const archiveConversation = ({ conversationId }) => {
  const dispatchPayload = {
    type: 'CHAT_CONVERSATION',
    id: conversationId,
    archived: true,
  }
  return sendDataToWS({
    action: 'CHAT_ARCHIVE_CONVERSATION',
    conversationId,
    dispatchPayload,
  })
}

export const markConversationAsRead = ({ conversationId, dispatchPayload }) => {
  return sendDataToWS({
    action: 'CHAT_MARK_CONVERSATION_READ',
    conversationId,
    dispatchPayload,
  })
}

export const searchConversations = ({ ack, archived, searchString }) =>
  sendDataToWS({
    action: 'CHAT_SEARCH_CONVERSATION',
    ack,
    searchString,
    archived,
  })
